import React from "react";
import Moment from "moment";
import { Row, Col, Card, Button, Divider, Form } from "antd";

import DrawerPanel from "../common/Drawer";
import FormInput from "../common/FormInput";

const AccountDetail = ({ onClose, drawer, showDrawer, user, getFieldDecorator, Fields, UserField }) => {

  const renderInput = (fields) => {
    if (fields === "company") {
    return (
      Fields &&
        Fields.map((field, index) => (<Form.Item>
        <FormInput key={index} field={field} getFieldDecorator={getFieldDecorator} />
      </Form.Item> ))
    );
    } else if (fields === "account") {
      return (
        Fields &&
        UserField.map((field, index) => (<Form.Item>
          <FormInput getFieldsValue key={index} field={field} getFieldDecorator={getFieldDecorator} />
        </Form.Item> ))
      );
    }
  };

  return (
    <div>
      <DrawerPanel
        onClose={onClose}
        visible={drawer.visible}
        title={drawer.title}
        width="450"
        input={() => renderInput(drawer.fields)}
      />

      <Row style={{ marginTop: 20 }}>
        <Col span={6}>
          <h3>Your Account</h3>
        </Col>
        <Col span={16} offset={2}>
          <Card style={{ width: "100%" }}>
            <Row>
              <Col span={18} push={6}>
                <p>{user && user.displayName}</p>
                {user && user.email}
              </Col>
              <Col span={6} pull={18}>
                <strong>Personal Info:</strong>
              </Col>
            </Row>
          </Card>
          <Card style={{ width: "100%" }}>
            <Row>
              <Col span={18} push={6}>
                <Button
                  onClick={() => showDrawer("account", "Update Username")}
                  style={{ float: "right", marginTop: -15 }}
                  type="link"
                >
                  edit
                </Button>
                <p>The Goat</p>
              </Col>
              <Col span={6} pull={18}>
                <strong>Username:</strong>
              </Col>
            </Row>
          </Card>
          <Card style={{ width: "100%", marginBottom: 10 }}>
            <Row>
              <Col span={18} push={6}>
                <p>
                  {user && Moment(user.createdAt.toDate()).format("MM/DD/YYYY")}
                </p>
              </Col>
              <Col span={6} pull={18}>
                <strong>Create Date:</strong>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <Divider />
      <Row style={{ marginTop: 30 }}>
        <Col span={6}>
          <h3>Your Company</h3>
        </Col>
        <Col span={16} offset={2}>
          <Card style={{ width: "100%" }}>
            <Row>
              <Col span={18} push={6}>
                <Button
                  onClick={() => showDrawer("company", "Update Company")}
                  style={{ float: "right", marginTop: -15 }}
                  type="link"
                >
                  edit
                </Button>
                <p>NFL League</p>
              </Col>
              <Col span={6} pull={18}>
                <strong>Name:</strong>
              </Col>
            </Row>
          </Card>
          <Card style={{ width: "100%" }}>
            <Row>
              <Col span={18} push={6}>
                <p>Hollywood FL</p>
                US
              </Col>
              <Col span={6} pull={18}>
                <strong>Address:</strong>
              </Col>
            </Row>
          </Card>
          <Card style={{ width: "100%" }}>
            <Row>
              <Col span={18} push={6}>
                <p>www.example.com</p>
              </Col>
              <Col span={6} pull={18}>
                <strong>Website:</strong>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default AccountDetail;
